/* eslint-disable*/
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
